import { foundationContext, Information } from '@philips-internal/oswald-ui-foundation';
import { getFoundationDataContext } from '../../../src/app/bootstrap-foundation';
import { AppointmentType, ScheduleType } from './pseudonym-types';

export default class PseudonymUtils {

  static parseScheduleTypeToAppointmentType(scheduleType: ScheduleType | string): AppointmentType {
    if (!scheduleType) {
      return AppointmentType.UNKNOW;
    }

    switch (scheduleType) {
      case ScheduleType.CHEMOTHERAPY: return AppointmentType.CHEMOTHERAPIES;
      case ScheduleType.CONSULTATION: return AppointmentType.CONSULTATIONS;
      case ScheduleType.EXAM: return AppointmentType.EXAMS;
      case ScheduleType.SERVICE: return AppointmentType.SERVICES;
      case ScheduleType.SURGERY: return AppointmentType.SURGERIES;
      default: return AppointmentType.UNKNOW;
    }
  }

  static parseAppointmentTypeToScheduleType(appointmentType: AppointmentType | string): ScheduleType {
    if (!appointmentType) {
      return ScheduleType.UNKNOW;
    }

    switch (appointmentType) {
      case AppointmentType.CHEMOTHERAPIES: return ScheduleType.CHEMOTHERAPY;
      case AppointmentType.CONSULTATIONS: return ScheduleType.CONSULTATION;
      case AppointmentType.EXAMS: return ScheduleType.EXAM;
      case AppointmentType.SERVICES: return ScheduleType.SERVICE;
      case AppointmentType.SURGERIES: return ScheduleType.SURGERY;
      default: return ScheduleType.UNKNOW;
    }
  }

  static getAppointmentTypeFromCurrentRoute(currentRoute: string): AppointmentType {
    if (this.hasRoute(AppointmentType.CONSULTATIONS, currentRoute)) { return AppointmentType.CONSULTATIONS; }
    if (this.hasRoute(AppointmentType.EXAMS, currentRoute)) { return AppointmentType.EXAMS; }
    if (this.hasRoute(AppointmentType.SERVICES, currentRoute)) { return AppointmentType.SERVICES; }
    if (this.hasRoute(AppointmentType.SURGERIES, currentRoute)) { return AppointmentType.SURGERIES; }
    if (this.hasRoute(AppointmentType.CHEMOTHERAPIES, currentRoute)) { return AppointmentType.CHEMOTHERAPIES; }
    if (this.hasRoute(AppointmentType.REQUEST, currentRoute)) { return AppointmentType.REQUEST; }
    if (this.hasRoute(AppointmentType.WAITING_LIST, currentRoute)) { return AppointmentType.WAITING_LIST; }
    return AppointmentType.UNKNOW;
  }

  static setDefaultContextInformation(): void {
    const appContext = getFoundationDataContext();
    const applicationInformationDataOriginal = appContext.get('applicationInformationData') as Information;

    foundationContext.clearInformation();
    foundationContext.setInformationOnce(applicationInformationDataOriginal);
  }

  private static hasRoute(route: string, currentRoute: string): boolean {
    return currentRoute.includes(route);
  }

}
